module.exports = __webpack_public_path__ + "static/media/full_width_version_mobile.4b9fdc26.jpg";